import { useMemo } from "react";
import { QRProps } from "@/contexts/QREditorContext/types";
import { usePreviewData } from "@/features/previews/shared/hooks/usePreviewData";

export function useUrlData(props: QRProps<"url">) {
  const { data, isInitPreview } = usePreviewData(props, {
    // Editor init preview: props may come from JSON without qrUrlLink; context has live form data.
    // Scan (/p, /qr): preview is false — props from API must win over global INITIAL_QR_DATA context.
    prioritizeContext: props.preview === true,
  });

  const qrUrlLink = useMemo(() => {
    return data?.qrUrlLink || "";
  }, [data?.qrUrlLink]);

  const translations = useMemo(() => {
    return {
      title1: props.previewTranslations?.["url"]?.preview_url_title_1,
      title2: props.previewTranslations?.["url"]?.preview_url_title_2,
    };
  }, [props.previewTranslations]);

  return {
    qrUrlLink,
    translations,
    isInitPreview,
    preview: props.preview,
  };
}
